// @flow

export const notificationStatus = {
  UNSENT: 0,
  SENDING: 5,
  SENT: 10,
  ERROR: 20,
  POST: 30,
  CORRECT: 40,
  ATTEND: 50,
  ABSENCE: 60,
};
